/**
 * Inventory Types — directApiClient queries (LF-3214)
 */

'use client';

import { directApiClient } from '@/lib/api/direct-client';
import {
  InventoryItemType,
  InventoryItemTypesListResponse,
  InventoryTypeActionResult
} from './types';

export async function getInventoryItemTypesAction(
  category?: 'asset' | 'liability'
): Promise<InventoryTypeActionResult<InventoryItemTypesListResponse>> {
  try {
    const params: Record<string, string> = {};
    if (category) params.category = category;

    const rawTypes = await directApiClient.get<
      Array<InventoryItemType & { slug?: string }>
    >('/inventory-item-types', {
      params
    });

    const types: InventoryItemType[] = rawTypes.map((type) => ({
      ...type,
      id: type.id || type.slug
    }));

    return {
      success: true,
      data: { types, total: types.length }
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to fetch inventory item types'
    };
  }
}
